export class SelectionReference
{
  targets:any[];
  key:string;  

  get values():any[]
  {

    return this.targets.map( t => t[ this.key ] );
  }

  set value( value:any )
  {

    this.targets.forEach( t => t[ this.key ] = value );
  }

  static from( object:any )
  {
    let reference = new SelectionReference();

    reference.targets = [ { root: object } ];
    reference.key = "root";

    return reference;
  }
}